import styled from "styled-components";

export const FooterContainer = styled.footer`
  background-color: "#F9FAFB";
  padding-top: 4rem;
  padding-bottom: 2rem;
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;

  @media (min-width: 640px) {
    max-width: 640px;
  }

  @media (min-width: 768px) {
    max-width: 768px;
  }

  @media (min-width: 1024px) {
    max-width: 1024px;
  }

  @media (min-width: 1280px) {
    max-width: 1280px;
  }

  @media (min-width: 1536px) {
    max-width: 1536px;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  margin-bottom: 3rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const Logo = styled.a``;

export const Text = styled.p`
  color: #1f2937;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  max-width: 300px;
`;

export const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
`;

export const SocialLink = styled.button`
  color: #1f2937;
  transition: color 0.3s;
  border: 0;
  background-color: transparent;

  &:hover {
    color: ${({ theme }) => theme.colors.primary[3]};
  }
`;

export const SectionTitle = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 1rem;
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ListItem = styled.li``;

export const Link = styled.a`
  color: #1f2937;
  list-style: none;
  text-decoration: none;
  transition: color 0.3s;

  &:hover {
    color: ${({ theme }) => theme.colors.primaryText[9]};
  }
`;

export const ContactItem = styled(ListItem)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const FooterBottom = styled.div`
  border-top: 1px solid #e5e7eb;
  padding-top: 2rem;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;

  p {
    margin: 0;
  }

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;
